export const UserPinType = {
  Application: 'application',
  Organization: 'organization',
  Project: 'project',
} as const;

export type UserPinType = (typeof UserPinType)[keyof typeof UserPinType];
